import { render, staticRenderFns } from "./TablaMatriz.vue?vue&type=template&id=6ca168ee&scoped=true&"
import script from "./TablaMatriz.vue?vue&type=script&lang=js&"
export * from "./TablaMatriz.vue?vue&type=script&lang=js&"
import style0 from "./TablaMatriz.vue?vue&type=style&index=0&id=6ca168ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca168ee",
  null
  
)

export default component.exports